const fixNav = document.querySelector('.fixNav')
const fixNavBase = document.querySelector('.fixNavBase')

const cta = document.querySelector('.entryCta')
const footer = document.querySelector('.footer')

if (fixNav) {
  const adjustFixNav = () => {
    if (window.scrollY <= 200) {
      fixNav.classList.remove('is-close')
      fixNavBase.classList.remove('is-close')
    } else {
      fixNav.classList.add('is-close')
      fixNavBase.classList.add('is-close')
    }

    const target = cta ? cta : footer
    const targetTop = target.getBoundingClientRect().top + window.scrollY
    if (window.scrollY + document.documentElement.clientHeight < targetTop) {
      fixNav.classList.remove('is-hide')
      fixNavBase.classList.remove('is-hide')
    } else {
      fixNav.classList.add('is-hide')
      fixNavBase.classList.add('is-hide')
    }
  }

  window.addEventListener('scroll', adjustFixNav)
  adjustFixNav()
}
